const loginUrl = '//backend-login-ui-v3.backend.out.nakamenosakura.com/'
const isBizLoginUrl = '//biz-marche-login-ui.isbe.out.nakamenosakura.com/'

export const environment = {
  production: false,
  environmentCd: 'dev',
  appCd: 'welcome',
  login: {
    // isbeLoginScript: '//backend-login-ui-v3.backend.out.nakamenosakura.com/wwwroot/js/be-login-core.js',
    // isbeLogin: '//backend-login-ui-v3.backend.out.nakamenosakura.com/',
    isbeLoginScript: isBizLoginUrl + 'wwwroot/js/be-login-core.js',
    isbeLogin: isBizLoginUrl,
    isbeAppCd: '',
    copyright: '',
  },
  api: {
    backendMacroBaseUrl: '//backend-macroapi.backend.out.nakamenosakura.com/',
    bisMarcheMacroBaseUrl: 'https://biz-marchemacroapi.isbe.out.nakamenosakura.com',
  },
  ui: {
    dashboardUIUrl: '//prototype-dashboard-ui.backend.out.nakamenosakura.com/',
  },
}
